export default "__VITE_ASSET__jDsFPuRN__"